import type { Dealer } from '../models/dealer';

export const getServices = (dealers: Dealer[]) => {
  const services: string[] = [];

  dealers.map((dealer) => {
    const dealerServices = dealer.services;
    dealerServices.map((dealerService) =>
      !services.includes(dealerService) ? services.push(dealerService) : dealerService,
    );
  });

  return services;
};
